/* eslint-disable max-len */
/* eslint-disable max-lines-per-function */
/* eslint-disable max-lines */
/* eslint-disable function-paren-newline */
import Button from "@atlaskit/button";
import { DateTimePicker } from "@atlaskit/datetime-picker";
import DynamicTable from "@atlaskit/dynamic-table";
import Form, { ErrorMessage, Field } from "@atlaskit/form";
import AddCircleIcon from "@atlaskit/icon/glyph/add-circle";
import Modal, {
    ModalBody,
    ModalFooter,
    ModalHeader,
    ModalTitle,
    ModalTransition,
} from "@atlaskit/modal-dialog";
import { ExitingPersistence, FadeIn } from "@atlaskit/motion";
import Spinner from "@atlaskit/spinner";
import TextField from "@atlaskit/textfield";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import weekday from "dayjs/plugin/weekday";
import React, { useContext, useEffect, useState } from "react";
import { getworkingHours as workingHours } from "../../components/TimeSlotDay/TimeSlotDay";
import { MessageContext } from "../../contexts/Message/MessageContext";
import APIService from "../../services/API";
import { createHead } from "./Head";
import { getTableRows } from "./Rows";

dayjs.extend(weekday);
dayjs.extend(utc);
dayjs.extend(timezone);

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface Props {}
export interface Blocker {
    id: number;
    coachId: string;
    startDateTime: string;
    endDateTime: string;
    blockerName: string;
}

export const Blockers = (props: Props) => {
    const [loadingBlockers, setLoadingBlockers] = useState(false);
    const [blockers, setBlockers] = useState<Blocker[]>([]);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [startTime, setStartTime] = useState<string>(
        dayjs().set("second", 0).set("minute", 0).set("hour", 0).toISOString()
    );
    const [name, setName] = useState<string | undefined>();
    const [endTime, setEndTime] = useState<string>(
        dayjs().set("second", 0).set("minute", 0).set("hour", 0).toISOString()
    );
    const [endTimeError, setEndTimeError] = useState<string>("");

    const messageContext = useContext(MessageContext);
    useEffect(() => {
        setLoadingBlockers(false);
        APIService.HandleGetRequest<Blocker[]>("/blockers")
            .then((response) => {
                setBlockers(response);
            })
            .catch((err) => {})
            .finally(() => setLoadingBlockers(false));
    }, []);
    
    const deleteBlocker = (id: number) => {
        setLoadingBlockers(true);
        APIService.handleDeleteRequest({}, `/blockers/${id}`)
            .then(() =>
                setBlockers([
                    ...blockers.filter((blocker) => blocker.id !== id),
                ])
            )
            .finally(() => {
                setLoadingBlockers(false);
                messageContext.actions.closeModal();
            });
    };
    
    const onDelete = (id: number) => {
        messageContext.actions.setMessage({
            title: "Möchten Sie diesen Blocker wirklich löschen?",
            isOpen: true,
            titleApparencce: "danger",
            buttons: [
                {
                    buttonText: "Ja",
                    onClick: () => deleteBlocker(id),
                },
                {
                    buttonText: "Nein",
                    onClick: () => messageContext.actions.closeModal(),
                },
            ],
        });
    };
    const submit = () => {
        const startDateTime = dayjs(startTime).set("millisecond", 0);
        const endDateTime = dayjs(endTime).set("millisecond", 0);

        if (!name) {
            setEndTimeError("Der Blockername muss angegeben werden");
        }
        else if (startDateTime.diff(endDateTime) > 0) {
            setEndTimeError("Die Endzeit sollte nach der Startzeit liegen");
        }
        else if (startDateTime.diff(endDateTime) === 0) {
            setEndTimeError("Blocker darf keine Länge von null Minuten haben");
        }
        else {
            setEndTimeError("");
            APIService.handlePostRequest<Partial<Blocker>, Blocker>(
                {
                    startDateTime: startDateTime.unix() as unknown as string,
                    endDateTime: endDateTime.unix() as unknown as string,
                    blockerName: name,
                },
                "/blockers"
            ).then((response) => {
                setIsOpenModal(false);
                setStartTime(
                    dayjs()
                        .set("second", 0)
                        .set("minute", 0)
                        .set("hour", 0)
                        .toISOString()
                );
                setEndTime(
                    dayjs()
                        .set("second", 0)
                        .set("minute", 0)
                        .set("hour", 0)
                        .toISOString()
                );
                setName("");
                setBlockers([...blockers, response]);
            });
        }
    };
    const dateTimePicker = (
        date: string,
        onChange: (value: string) => void,
        minDate: string,
        error: string,
        label: string
    ) => (
        <Field name="preference" label={label} defaultValue="" isRequired>
            {({ fieldProps: { id } }) => (
                <>
                    <DateTimePicker
                        locale="de"
                        value={date}
                        datePickerProps={{
                            placeholder: "",
                            minDate,
                        }}
                        onChange={onChange}
                        datePickerSelectProps={{
                            placeholder: "",
                            inputId: id,
                        }}
                        timePickerProps={{
                            times: workingHours(),
                        }}
                        timePickerSelectProps={{
                            times: workingHours(),
                            "aria-labelledby": `${id}-label`,
                            placeholder: "00:00",
                        }}
                    />
                    {error && <ErrorMessage>{error}</ErrorMessage>}
                </>
            )}
        </Field>
    );
    return (
        <div className="blockers-container">
            <ExitingPersistence>
                {loadingBlockers && (
                    <FadeIn>
                        {() => (
                            <span>
                                <Spinner size="xlarge" />
                            </span>
                        )}
                    </FadeIn>
                )}
            </ExitingPersistence>

            <ExitingPersistence appear>
                {!loadingBlockers && (
                    <FadeIn>
                        {() => (
                            <div className="blockers-wrapper">
                                {" "}
                                <DynamicTable
                                    caption={
                                        <div className="caption-wrapper">
                                            Blocker
                                            <div
                                                onClick={() =>
                                                    setIsOpenModal(true)
                                                }
                                                className="blocker-add"
                                            >
                                                <AddCircleIcon label="Add" />
                                            </div>
                                        </div>
                                    }
                                    isLoading={loadingBlockers}
                                    head={createHead()}
                                    rows={getTableRows(
                                        blockers.sort(
                                            (blocker1, blocker2) =>
                                                parseInt(
                                                    blocker1.startDateTime,
                                                    10
                                                ) -
                                                parseInt(
                                                    blocker2.startDateTime,
                                                    10
                                                )
                                        ),
                                        onDelete
                                    )}
                                    /*
                                     * head={createHead(Boolean(filter.afterDate))}
                                     * rows={getTableRows(
                                     *     Boolean(filter.afterDate)
                                     * )}
                                     */
                                    isFixedSize
                                />
                            </div>
                        )}
                    </FadeIn>
                )}
            </ExitingPersistence>
            <ModalTransition>
                {isOpenModal && (
                    <Modal onClose={() => setIsOpenModal(false)}>
                        <ModalHeader>
                            <ModalTitle> Neuen Blocker hinzufügen</ModalTitle>
                        </ModalHeader>
                        <ModalBody>
                            <Form<FormData> onSubmit={(data) => {}}>
                                {({ formProps }) => (
                                    <form {...formProps}>
                                        <Field
                                            aria-required={true}
                                            name="blockername"
                                            label="Blockername"
                                            isRequired
                                        >
                                            {({ fieldProps, error }) => (
                                                <>
                                                    <TextField
                                                        onChange={(
                                                            event: React.ChangeEvent<HTMLInputElement>
                                                        ) =>
                                                            setName(
                                                                event.target
                                                                    .value
                                                            )
                                                        }
                                                        value={name}
                                                        autoComplete="off"
                                                    />
                                                </>
                                            )}
                                        </Field>{" "}
                                        {dateTimePicker(
                                            startTime,
                                            (value: string) => {
                                                setStartTime(value);
                                            },
                                            dayjs().format("YYYY-MM-DD"),
                                            "",
                                            "Terminbeginn"
                                        )}
                                        {dateTimePicker(
                                            endTime,
                                            (value: string) => {
                                                setEndTime(value);
                                            },
                                            dayjs(startTime).format(
                                                "YYYY-MM-DD"
                                            ),
                                            endTimeError,
                                            "Terminende"
                                        )}
                                    </form>
                                )}
                            </Form>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                onClick={() => setIsOpenModal(false)}
                                appearance="subtle"
                            >
                                Abbrechen
                            </Button>
                            <Button
                                appearance="primary"
                                isDisabled={!startTime || !endTime}
                                onClick={submit}
                                autoFocus
                            >
                                Speichern
                            </Button>
                        </ModalFooter>
                    </Modal>
                )}
            </ModalTransition>
        </div>
    );
};
